import React from "react"
import { Box } from "@mui/material"
import { AppCheckCrossIcon } from "@components"

export default function booleanColumn({ label, value }) {
	return [{
		name: value,
		label: label,
		options: {
			filterType: 'checkbox',
			customBodyRowRender: cellValue => cellValue ? 'Yes' : 'No'
		},
	}, {
		name: value,
		label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: cellValue => (
				<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<AppCheckCrossIcon condition={!!cellValue}/>
				</Box>
			),
		},
	}]
}
